import type { Client } from '@stomp/stompjs';
import { createContext, use } from 'react';
import useSocket from '../../prelude/useSocket';

export interface ISocketContext {
  loading: boolean;
  connected: boolean;
  client: Client | null;
  error?: string;
}

const SocketContext = createContext<ISocketContext>({ loading: false, client: null, connected: false, error: '' });

export const useSocketCtx = (): ISocketContext => use(SocketContext);

export const SocketProvider: React.FC = ({ children }) => {
  const { loading, client, connected, error } = useSocket();
  if (!loading) {
    return <SocketContext.Provider value={{ loading, client, connected, error }}>{children}</SocketContext.Provider>;
  }
  return <></>;
};
